import useGameMediaDownload from './useGameMediaDownload';

const useGameVideos = () => {
  const { handleDownload, isLoading, progress } = useGameMediaDownload('videos');

  return {
    downloadVideos: handleDownload,
    isLoading,
    progress,
  };
};

export default useGameVideos;
